const PushNotificationIOS = {
  FetchResult: {
    NoData: 'NoData'
  }
};

export default PushNotificationIOS;
